import { Locales } from './Locales';

export const europeanUnionCountries = [
  Locales.AT,
  Locales.BG,
  Locales.BE,
  Locales.CZ,
  Locales.CY,
  Locales.DE,
  Locales.DK,
  Locales.GR,
  Locales.IE,
  Locales.IT,
  Locales.HR,
  Locales.HU,
  Locales.EE,
  Locales.ES,
  Locales.LT,
  Locales.LU,
  Locales.LV,
  Locales.ME,
  Locales.MK,
  Locales.MT,
  Locales.NL,
  Locales.PL,
  Locales.PT,
  Locales.RO,
  Locales.SI,
  Locales.SK,
  Locales.FI,
  Locales.FR,
  Locales.SE,
];

const europeanOtherCountries = [
  Locales.AL,
  Locales.CH,
  Locales.GB,
  Locales.IS,
  Locales.LI,
  Locales.ME,
  Locales.MK,
  Locales.NO,
];

export const europeanCountries = [...europeanUnionCountries, ...europeanOtherCountries];

export const asiaCountries = [Locales.CN, Locales.HK, Locales.SG];

export const countriesWithConsentCheck = [
  ...europeanUnionCountries,
  Locales.GB,
  Locales.CH,
  Locales.IS,
  Locales.DK,
  Locales.LI,
  Locales.US,
];

export const complianceCountries = [
  Locales.US,
  Locales.UA,
  Locales.PR,
  Locales.GU,
  Locales.VI,
  Locales.MP,
  Locales.AS,
  Locales.UM,
];
